/* tslint:disable */
/* eslint-disable */
/**
 * Ак Барс Недвижимость API
 * Инструменты разработчика:  [ [Документация API. Swagger](/docs/) ]  [ [Документация API. Redoc](/redoc/) ] [ [Панель администрирования](/admin/) ] [ [Документация Image-Service](/api/attachments/docs/) ]
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
  AppealBooking,
  AppealBookingFromJSON,
  AppealBookingToJSON,
  AppealConsultation,
  AppealConsultationFromJSON,
  AppealConsultationToJSON,
  ChangeOwner,
  ChangeOwnerFromJSON,
  ChangeOwnerToJSON,
  ContractDataSign,
  ContractDataSignFromJSON,
  ContractDataSignToJSON,
  Deal,
  DealFromJSON,
  DealToJSON,
  DealCreate,
  DealCreateFromJSON,
  DealCreateToJSON,
  DealNote,
  DealNoteFromJSON,
  DealNoteToJSON,
  DealUpdate,
  DealUpdateFromJSON,
  DealUpdateToJSON,
  Document,
  DocumentFromJSON,
  DocumentToJSON,
  DocumentChange,
  DocumentChangeFromJSON,
  DocumentChangeToJSON,
  InlineResponse2004,
  InlineResponse2004FromJSON,
  InlineResponse2004ToJSON,
  InlineResponse2005,
  InlineResponse2005FromJSON,
  InlineResponse2005ToJSON,
  InlineResponse2006,
  InlineResponse2006FromJSON,
  InlineResponse2006ToJSON,
  InlineResponse2007,
  InlineResponse2007FromJSON,
  InlineResponse2007ToJSON,
  InlineResponse2008,
  InlineResponse2008FromJSON,
  InlineResponse2008ToJSON,
  Note,
  NoteFromJSON,
  NoteToJSON,
  Owners,
  OwnersFromJSON,
  OwnersToJSON,
  OwnershipTypesResponse,
  OwnershipTypesResponseFromJSON,
  OwnershipTypesResponseToJSON,
  PaymentTypesResponse,
  PaymentTypesResponseFromJSON,
  PaymentTypesResponseToJSON,
} from '../models';

export interface BookingV1BookingCreateRequest {
  data: AppealBooking;
}

export interface BookingV1BookingDeleteRequest {
  id: number;
}

export interface BookingV1BookingListRequest {
  search?: string;
  ordering?: string;
  limit?: number;
  offset?: number;
}

export interface BookingV1ConsultationCreateRequest {
  data: AppealConsultation;
}

export interface BookingV1ConsultationListRequest {
  estate?: string;
  limit?: number;
  offset?: number;
}

export interface BookingV1ContractDateCreateRequest {
  data: ContractDataSign;
}

export interface BookingV1DealCreateRequest {
  data: DealCreate;
}

export interface BookingV1DealDocumentCreateRequest {
  data: Document;
}

export interface BookingV1DealDocumentDeleteRequest {
  id: number;
}

export interface BookingV1DealDocumentListRequest {
  limit?: number;
  offset?: number;
}

export interface BookingV1DealDocumentPartialUpdateRequest {
  id: number;
  data: DocumentChange;
}

export interface BookingV1DealDocumentReadRequest {
  id: number;
}

export interface BookingV1DealNoteCreateRequest {
  data: DealNote;
}

export interface BookingV1DealOwnerCreateRequest {
  data: Owners;
}

export interface BookingV1DealOwnerDeleteRequest {
  id: number;
}

export interface BookingV1DealOwnerDocumentCreateRequest {
  data: Document;
}

export interface BookingV1DealOwnerDocumentDeleteRequest {
  id: number;
}

export interface BookingV1DealOwnerDocumentListRequest {
  limit?: number;
  offset?: number;
}

export interface BookingV1DealOwnerDocumentPartialUpdateRequest {
  id: number;
  data: DocumentChange;
}

export interface BookingV1DealOwnerDocumentReadRequest {
  id: number;
}

export interface BookingV1DealOwnerListRequest {
  search?: string;
  ordering?: string;
  limit?: number;
  offset?: number;
}

export interface BookingV1DealOwnerPartialUpdateRequest {
  id: number;
  data: ChangeOwner;
}

export interface BookingV1DealOwnerReadRequest {
  id: number;
}

export interface BookingV1DealPartialUpdateRequest {
  data: DealUpdate;
}

export interface BookingV1NoteCreateRequest {
  data: Note;
}

export interface MortgageRequest {
  data: { leadId: number };
}

export interface BookingV1NoteListRequest {
  search?: string;
  ordering?: string;
  limit?: number;
  offset?: number;
}

/**
 *
 */
export class BookingApi extends runtime.BaseAPI {
  /**
   */
  async bookingV1BookingCreateRaw(
    requestParameters: BookingV1BookingCreateRequest
  ): Promise<runtime.ApiResponse<AppealBooking>> {
    if (requestParameters.data === null || requestParameters.data === undefined) {
      throw new runtime.RequiredError(
        'data',
        'Required parameter requestParameters.data was null or undefined when calling bookingV1BookingCreate.'
      );
    }

    const queryParameters: runtime.HTTPQuery = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-App-Version'] = this.configuration.apiKey('X-App-Version'); // AppVersion authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Authorization'] = this.configuration.apiKey('Authorization'); // Bearer authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Device-Id'] = this.configuration.apiKey('X-Device-Id'); // DeviceId authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Device-Type'] = this.configuration.apiKey('X-Device-Type'); // DeviceType authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Os-Version'] = this.configuration.apiKey('X-Os-Version'); // OsVersion authentication
    }

    const response = await this.request({
      path: `/booking/v1/booking/`,
      method: 'POST',
      headers: headerParameters,
      query: queryParameters,
      body: AppealBookingToJSON(requestParameters.data),
    });

    return new runtime.JSONApiResponse(response, jsonValue => AppealBookingFromJSON(jsonValue));
  }

  /**
   */
  async bookingV1BookingCreate(requestParameters: BookingV1BookingCreateRequest): Promise<AppealBooking> {
    const response = await this.bookingV1BookingCreateRaw(requestParameters);
    return await response.value();
  }

  /**
   * Удаление недавно созданной заявки на бронь
   */
  async bookingV1BookingDeleteRaw(
    requestParameters: BookingV1BookingDeleteRequest
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters.id === null || requestParameters.id === undefined) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter requestParameters.id was null or undefined when calling bookingV1BookingDelete.'
      );
    }

    const queryParameters: runtime.HTTPQuery = {};

    if (requestParameters.id !== undefined) {
      queryParameters['id'] = requestParameters.id;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-App-Version'] = this.configuration.apiKey('X-App-Version'); // AppVersion authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Authorization'] = this.configuration.apiKey('Authorization'); // Bearer authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Device-Id'] = this.configuration.apiKey('X-Device-Id'); // DeviceId authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Device-Type'] = this.configuration.apiKey('X-Device-Type'); // DeviceType authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Os-Version'] = this.configuration.apiKey('X-Os-Version'); // OsVersion authentication
    }

    const response = await this.request({
      path: `/booking/v1/booking/`,
      method: 'DELETE',
      headers: headerParameters,
      query: queryParameters,
    });

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Удаление недавно созданной заявки на бронь
   */
  async bookingV1BookingDelete(requestParameters: BookingV1BookingDeleteRequest): Promise<void> {
    await this.bookingV1BookingDeleteRaw(requestParameters);
  }

  /**
   */
  async bookingV1BookingListRaw(
    requestParameters: BookingV1BookingListRequest
  ): Promise<runtime.ApiResponse<InlineResponse2004>> {
    const queryParameters: runtime.HTTPQuery = {};

    if (requestParameters.search !== undefined) {
      queryParameters['search'] = requestParameters.search;
    }

    if (requestParameters.ordering !== undefined) {
      queryParameters['ordering'] = requestParameters.ordering;
    }

    if (requestParameters.limit !== undefined) {
      queryParameters['limit'] = requestParameters.limit;
    }

    if (requestParameters.offset !== undefined) {
      queryParameters['offset'] = requestParameters.offset;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-App-Version'] = this.configuration.apiKey('X-App-Version'); // AppVersion authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Authorization'] = this.configuration.apiKey('Authorization'); // Bearer authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Device-Id'] = this.configuration.apiKey('X-Device-Id'); // DeviceId authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Device-Type'] = this.configuration.apiKey('X-Device-Type'); // DeviceType authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Os-Version'] = this.configuration.apiKey('X-Os-Version'); // OsVersion authentication
    }

    const response = await this.request({
      path: `/booking/v1/booking/`,
      method: 'GET',
      headers: headerParameters,
      query: queryParameters,
    });

    return new runtime.JSONApiResponse(response, jsonValue => InlineResponse2004FromJSON(jsonValue));
  }

  /**
   */
  async bookingV1BookingList(requestParameters: BookingV1BookingListRequest): Promise<InlineResponse2004> {
    const response = await this.bookingV1BookingListRaw(requestParameters);
    return await response.value();
  }

  /**
   */
  async bookingV1ConsultationCreateRaw(
    requestParameters: BookingV1ConsultationCreateRequest
  ): Promise<runtime.ApiResponse<AppealConsultation>> {
    if (requestParameters.data === null || requestParameters.data === undefined) {
      throw new runtime.RequiredError(
        'data',
        'Required parameter requestParameters.data was null or undefined when calling bookingV1ConsultationCreate.'
      );
    }

    const queryParameters: runtime.HTTPQuery = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-App-Version'] = this.configuration.apiKey('X-App-Version'); // AppVersion authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Authorization'] = this.configuration.apiKey('Authorization'); // Bearer authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Device-Id'] = this.configuration.apiKey('X-Device-Id'); // DeviceId authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Device-Type'] = this.configuration.apiKey('X-Device-Type'); // DeviceType authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Os-Version'] = this.configuration.apiKey('X-Os-Version'); // OsVersion authentication
    }

    const response = await this.request({
      path: `/booking/v1/consultation/`,
      method: 'POST',
      headers: headerParameters,
      query: queryParameters,
      body: AppealConsultationToJSON(requestParameters.data),
    });

    return new runtime.JSONApiResponse(response, jsonValue => AppealConsultationFromJSON(jsonValue));
  }

  /**
   */
  async bookingV1ConsultationCreate(
    requestParameters: BookingV1ConsultationCreateRequest
  ): Promise<AppealConsultation> {
    const response = await this.bookingV1ConsultationCreateRaw(requestParameters);
    return await response.value();
  }

  /**
   */
  async bookingV1ConsultationListRaw(
    requestParameters: BookingV1ConsultationListRequest
  ): Promise<runtime.ApiResponse<InlineResponse2005>> {
    const queryParameters: runtime.HTTPQuery = {};

    if (requestParameters.estate !== undefined) {
      queryParameters['estate'] = requestParameters.estate;
    }

    if (requestParameters.limit !== undefined) {
      queryParameters['limit'] = requestParameters.limit;
    }

    if (requestParameters.offset !== undefined) {
      queryParameters['offset'] = requestParameters.offset;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-App-Version'] = this.configuration.apiKey('X-App-Version'); // AppVersion authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Authorization'] = this.configuration.apiKey('Authorization'); // Bearer authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Device-Id'] = this.configuration.apiKey('X-Device-Id'); // DeviceId authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Device-Type'] = this.configuration.apiKey('X-Device-Type'); // DeviceType authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Os-Version'] = this.configuration.apiKey('X-Os-Version'); // OsVersion authentication
    }

    const response = await this.request({
      path: `/booking/v1/consultation/`,
      method: 'GET',
      headers: headerParameters,
      query: queryParameters,
    });

    return new runtime.JSONApiResponse(response, jsonValue => InlineResponse2005FromJSON(jsonValue));
  }

  /**
   */
  async bookingV1ConsultationList(requestParameters: BookingV1ConsultationListRequest): Promise<InlineResponse2005> {
    const response = await this.bookingV1ConsultationListRaw(requestParameters);
    return await response.value();
  }

  /**
   * Метод отправки инфомации о согласовании договора
   */
  async bookingV1ContractAgreedListRaw(): Promise<runtime.ApiResponse<void>> {
    const queryParameters: runtime.HTTPQuery = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-App-Version'] = this.configuration.apiKey('X-App-Version'); // AppVersion authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Authorization'] = this.configuration.apiKey('Authorization'); // Bearer authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Device-Id'] = this.configuration.apiKey('X-Device-Id'); // DeviceId authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Device-Type'] = this.configuration.apiKey('X-Device-Type'); // DeviceType authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Os-Version'] = this.configuration.apiKey('X-Os-Version'); // OsVersion authentication
    }

    const response = await this.request({
      path: `/booking/v1/contract/agreed/`,
      method: 'GET',
      headers: headerParameters,
      query: queryParameters,
    });

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Метод отправки инфомации о согласовании договора
   */
  async bookingV1ContractAgreedList(): Promise<void> {
    await this.bookingV1ContractAgreedListRaw();
  }

  /**
   */
  async bookingV1ContractDateCreateRaw(
    requestParameters: BookingV1ContractDateCreateRequest
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters.data === null || requestParameters.data === undefined) {
      throw new runtime.RequiredError(
        'data',
        'Required parameter requestParameters.data was null or undefined when calling bookingV1ContractDateCreate.'
      );
    }

    const queryParameters: runtime.HTTPQuery = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-App-Version'] = this.configuration.apiKey('X-App-Version'); // AppVersion authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Authorization'] = this.configuration.apiKey('Authorization'); // Bearer authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Device-Id'] = this.configuration.apiKey('X-Device-Id'); // DeviceId authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Device-Type'] = this.configuration.apiKey('X-Device-Type'); // DeviceType authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Os-Version'] = this.configuration.apiKey('X-Os-Version'); // OsVersion authentication
    }

    const response = await this.request({
      path: `/booking/v1/contract/date/`,
      method: 'POST',
      headers: headerParameters,
      query: queryParameters,
      body: ContractDataSignToJSON(requestParameters.data),
    });

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async bookingV1ContractDateCreate(requestParameters: BookingV1ContractDateCreateRequest): Promise<void> {
    await this.bookingV1ContractDateCreateRaw(requestParameters);
  }

  /**
   * Метод для скачивания файла договора
   */
  async bookingV1ContractListRaw(): Promise<runtime.ApiResponse<Blob>> {
    const queryParameters: runtime.HTTPQuery = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-App-Version'] = this.configuration.apiKey('X-App-Version'); // AppVersion authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Authorization'] = this.configuration.apiKey('Authorization'); // Bearer authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Device-Id'] = this.configuration.apiKey('X-Device-Id'); // DeviceId authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Device-Type'] = this.configuration.apiKey('X-Device-Type'); // DeviceType authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Os-Version'] = this.configuration.apiKey('X-Os-Version'); // OsVersion authentication
    }

    const response = await this.request({
      path: `/booking/v1/contract/`,
      method: 'GET',
      headers: headerParameters,
      query: queryParameters,
    });

    return new runtime.BlobApiResponse(response);
  }

  /**
   * Метод для скачивания файла договора
   */
  async bookingV1ContractList(): Promise<Blob> {
    const response = await this.bookingV1ContractListRaw();
    return await response.value();
  }

  /**
   */
  async bookingV1DealCreateRaw(
    requestParameters: BookingV1DealCreateRequest
  ): Promise<runtime.ApiResponse<DealCreate>> {
    if (requestParameters.data === null || requestParameters.data === undefined) {
      throw new runtime.RequiredError(
        'data',
        'Required parameter requestParameters.data was null or undefined when calling bookingV1DealCreate.'
      );
    }

    const queryParameters: runtime.HTTPQuery = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-App-Version'] = this.configuration.apiKey('X-App-Version'); // AppVersion authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Authorization'] = this.configuration.apiKey('Authorization'); // Bearer authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Device-Id'] = this.configuration.apiKey('X-Device-Id'); // DeviceId authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Device-Type'] = this.configuration.apiKey('X-Device-Type'); // DeviceType authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Os-Version'] = this.configuration.apiKey('X-Os-Version'); // OsVersion authentication
    }

    const response = await this.request({
      path: `/booking/v1/deal/`,
      method: 'POST',
      headers: headerParameters,
      query: queryParameters,
      body: DealCreateToJSON(requestParameters.data),
    });

    return new runtime.JSONApiResponse(response, jsonValue => DealCreateFromJSON(jsonValue));
  }

  /**
   */
  async bookingV1DealCreate(requestParameters: BookingV1DealCreateRequest): Promise<DealCreate> {
    const response = await this.bookingV1DealCreateRaw(requestParameters);
    return await response.value();
  }

  /**
   */
  async bookingV1DealDocumentCreateRaw(
    requestParameters: BookingV1DealDocumentCreateRequest
  ): Promise<runtime.ApiResponse<Document>> {
    if (requestParameters.data === null || requestParameters.data === undefined) {
      throw new runtime.RequiredError(
        'data',
        'Required parameter requestParameters.data was null or undefined when calling bookingV1DealDocumentCreate.'
      );
    }

    const queryParameters: runtime.HTTPQuery = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-App-Version'] = this.configuration.apiKey('X-App-Version'); // AppVersion authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Authorization'] = this.configuration.apiKey('Authorization'); // Bearer authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Device-Id'] = this.configuration.apiKey('X-Device-Id'); // DeviceId authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Device-Type'] = this.configuration.apiKey('X-Device-Type'); // DeviceType authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Os-Version'] = this.configuration.apiKey('X-Os-Version'); // OsVersion authentication
    }

    const response = await this.request({
      path: `/booking/v1/deal/document/`,
      method: 'POST',
      headers: headerParameters,
      query: queryParameters,
      body: DocumentToJSON(requestParameters.data),
    });

    return new runtime.JSONApiResponse(response, jsonValue => DocumentFromJSON(jsonValue));
  }

  /**
   */
  async bookingV1DealDocumentCreate(requestParameters: BookingV1DealDocumentCreateRequest): Promise<Document> {
    const response = await this.bookingV1DealDocumentCreateRaw(requestParameters);
    return await response.value();
  }

  /**
   */
  async bookingV1DealDocumentDeleteRaw(
    requestParameters: BookingV1DealDocumentDeleteRequest
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters.id === null || requestParameters.id === undefined) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter requestParameters.id was null or undefined when calling bookingV1DealDocumentDelete.'
      );
    }

    const queryParameters: runtime.HTTPQuery = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-App-Version'] = this.configuration.apiKey('X-App-Version'); // AppVersion authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Authorization'] = this.configuration.apiKey('Authorization'); // Bearer authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Device-Id'] = this.configuration.apiKey('X-Device-Id'); // DeviceId authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Device-Type'] = this.configuration.apiKey('X-Device-Type'); // DeviceType authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Os-Version'] = this.configuration.apiKey('X-Os-Version'); // OsVersion authentication
    }

    const response = await this.request({
      path: `/booking/v1/deal/document/{id}/`.replace(`{${'id'}}`, encodeURIComponent(String(requestParameters.id))),
      method: 'DELETE',
      headers: headerParameters,
      query: queryParameters,
    });

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async bookingV1DealDocumentDelete(requestParameters: BookingV1DealDocumentDeleteRequest): Promise<void> {
    await this.bookingV1DealDocumentDeleteRaw(requestParameters);
  }

  /**
   */
  async bookingV1DealDocumentListRaw(
    requestParameters: BookingV1DealDocumentListRequest
  ): Promise<runtime.ApiResponse<InlineResponse2006>> {
    const queryParameters: runtime.HTTPQuery = {};

    if (requestParameters.limit !== undefined) {
      queryParameters['limit'] = requestParameters.limit;
    }

    if (requestParameters.offset !== undefined) {
      queryParameters['offset'] = requestParameters.offset;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-App-Version'] = this.configuration.apiKey('X-App-Version'); // AppVersion authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Authorization'] = this.configuration.apiKey('Authorization'); // Bearer authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Device-Id'] = this.configuration.apiKey('X-Device-Id'); // DeviceId authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Device-Type'] = this.configuration.apiKey('X-Device-Type'); // DeviceType authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Os-Version'] = this.configuration.apiKey('X-Os-Version'); // OsVersion authentication
    }

    const response = await this.request({
      path: `/booking/v1/deal/document/`,
      method: 'GET',
      headers: headerParameters,
      query: queryParameters,
    });

    return new runtime.JSONApiResponse(response, jsonValue => InlineResponse2006FromJSON(jsonValue));
  }

  /**
   */
  async bookingV1DealDocumentList(requestParameters: BookingV1DealDocumentListRequest): Promise<InlineResponse2006> {
    const response = await this.bookingV1DealDocumentListRaw(requestParameters);
    return await response.value();
  }

  /**
   */
  async bookingV1DealDocumentPartialUpdateRaw(
    requestParameters: BookingV1DealDocumentPartialUpdateRequest
  ): Promise<runtime.ApiResponse<DocumentChange>> {
    if (requestParameters.id === null || requestParameters.id === undefined) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter requestParameters.id was null or undefined when calling bookingV1DealDocumentPartialUpdate.'
      );
    }

    if (requestParameters.data === null || requestParameters.data === undefined) {
      throw new runtime.RequiredError(
        'data',
        'Required parameter requestParameters.data was null or undefined when calling bookingV1DealDocumentPartialUpdate.'
      );
    }

    const queryParameters: runtime.HTTPQuery = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-App-Version'] = this.configuration.apiKey('X-App-Version'); // AppVersion authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Authorization'] = this.configuration.apiKey('Authorization'); // Bearer authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Device-Id'] = this.configuration.apiKey('X-Device-Id'); // DeviceId authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Device-Type'] = this.configuration.apiKey('X-Device-Type'); // DeviceType authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Os-Version'] = this.configuration.apiKey('X-Os-Version'); // OsVersion authentication
    }

    const response = await this.request({
      path: `/booking/v1/deal/document/{id}/`.replace(`{${'id'}}`, encodeURIComponent(String(requestParameters.id))),
      method: 'PATCH',
      headers: headerParameters,
      query: queryParameters,
      body: DocumentChangeToJSON(requestParameters.data),
    });

    return new runtime.JSONApiResponse(response, jsonValue => DocumentChangeFromJSON(jsonValue));
  }

  /**
   */
  async bookingV1DealDocumentPartialUpdate(
    requestParameters: BookingV1DealDocumentPartialUpdateRequest
  ): Promise<DocumentChange> {
    const response = await this.bookingV1DealDocumentPartialUpdateRaw(requestParameters);
    return await response.value();
  }

  /**
   */
  async bookingV1DealDocumentReadRaw(
    requestParameters: BookingV1DealDocumentReadRequest
  ): Promise<runtime.ApiResponse<DocumentChange>> {
    if (requestParameters.id === null || requestParameters.id === undefined) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter requestParameters.id was null or undefined when calling bookingV1DealDocumentRead.'
      );
    }

    const queryParameters: runtime.HTTPQuery = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-App-Version'] = this.configuration.apiKey('X-App-Version'); // AppVersion authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Authorization'] = this.configuration.apiKey('Authorization'); // Bearer authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Device-Id'] = this.configuration.apiKey('X-Device-Id'); // DeviceId authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Device-Type'] = this.configuration.apiKey('X-Device-Type'); // DeviceType authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Os-Version'] = this.configuration.apiKey('X-Os-Version'); // OsVersion authentication
    }

    const response = await this.request({
      path: `/booking/v1/deal/document/{id}/`.replace(`{${'id'}}`, encodeURIComponent(String(requestParameters.id))),
      method: 'GET',
      headers: headerParameters,
      query: queryParameters,
    });

    return new runtime.JSONApiResponse(response, jsonValue => DocumentChangeFromJSON(jsonValue));
  }

  /**
   */
  async bookingV1DealDocumentRead(requestParameters: BookingV1DealDocumentReadRequest): Promise<DocumentChange> {
    const response = await this.bookingV1DealDocumentReadRaw(requestParameters);
    return await response.value();
  }

  /**
   */
  async bookingV1DealFinishReadRaw(): Promise<runtime.ApiResponse<Deal>> {
    const queryParameters: runtime.HTTPQuery = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-App-Version'] = this.configuration.apiKey('X-App-Version'); // AppVersion authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Authorization'] = this.configuration.apiKey('Authorization'); // Bearer authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Device-Id'] = this.configuration.apiKey('X-Device-Id'); // DeviceId authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Device-Type'] = this.configuration.apiKey('X-Device-Type'); // DeviceType authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Os-Version'] = this.configuration.apiKey('X-Os-Version'); // OsVersion authentication
    }

    const response = await this.request({
      path: `/booking/v1/deal/finish/`,
      method: 'GET',
      headers: headerParameters,
      query: queryParameters,
    });

    return new runtime.JSONApiResponse(response, jsonValue => DealFromJSON(jsonValue));
  }

  /**
   */
  async bookingV1DealFinishRead(): Promise<Deal> {
    const response = await this.bookingV1DealFinishReadRaw();
    return await response.value();
  }

  /**
   * Метод отправки инфомации о согласовании договора
   */
  async bookingV1DealNoteCreateRaw(
    requestParameters: BookingV1DealNoteCreateRequest
  ): Promise<runtime.ApiResponse<Deal>> {
    if (requestParameters.data === null || requestParameters.data === undefined) {
      throw new runtime.RequiredError(
        'data',
        'Required parameter requestParameters.data was null or undefined when calling bookingV1DealNoteCreate.'
      );
    }

    const queryParameters: runtime.HTTPQuery = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-App-Version'] = this.configuration.apiKey('X-App-Version'); // AppVersion authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Authorization'] = this.configuration.apiKey('Authorization'); // Bearer authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Device-Id'] = this.configuration.apiKey('X-Device-Id'); // DeviceId authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Device-Type'] = this.configuration.apiKey('X-Device-Type'); // DeviceType authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Os-Version'] = this.configuration.apiKey('X-Os-Version'); // OsVersion authentication
    }

    const response = await this.request({
      path: `/booking/v1/deal/note/`,
      method: 'POST',
      headers: headerParameters,
      query: queryParameters,
      body: DealNoteToJSON(requestParameters.data),
    });

    return new runtime.JSONApiResponse(response, jsonValue => DealFromJSON(jsonValue));
  }

  /**
   * Метод отправки инфомации о согласовании договора
   */
  async bookingV1DealNoteCreate(requestParameters: BookingV1DealNoteCreateRequest): Promise<Deal> {
    const response = await this.bookingV1DealNoteCreateRaw(requestParameters);
    return await response.value();
  }

  /**
   */
  async bookingV1DealOwnerCreateRaw(
    requestParameters: BookingV1DealOwnerCreateRequest
  ): Promise<runtime.ApiResponse<Owners>> {
    if (requestParameters.data === null || requestParameters.data === undefined) {
      throw new runtime.RequiredError(
        'data',
        'Required parameter requestParameters.data was null or undefined when calling bookingV1DealOwnerCreate.'
      );
    }

    const queryParameters: runtime.HTTPQuery = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-App-Version'] = this.configuration.apiKey('X-App-Version'); // AppVersion authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Authorization'] = this.configuration.apiKey('Authorization'); // Bearer authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Device-Id'] = this.configuration.apiKey('X-Device-Id'); // DeviceId authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Device-Type'] = this.configuration.apiKey('X-Device-Type'); // DeviceType authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Os-Version'] = this.configuration.apiKey('X-Os-Version'); // OsVersion authentication
    }

    const response = await this.request({
      path: `/booking/v1/deal/owner/`,
      method: 'POST',
      headers: headerParameters,
      query: queryParameters,
      body: OwnersToJSON(requestParameters.data),
    });

    return new runtime.JSONApiResponse(response, jsonValue => OwnersFromJSON(jsonValue));
  }

  /**
   */
  async bookingV1DealOwnerCreate(requestParameters: BookingV1DealOwnerCreateRequest): Promise<Owners> {
    const response = await this.bookingV1DealOwnerCreateRaw(requestParameters);
    return await response.value();
  }

  /**
   */
  async bookingV1DealOwnerDeleteRaw(
    requestParameters: BookingV1DealOwnerDeleteRequest
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters.id === null || requestParameters.id === undefined) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter requestParameters.id was null or undefined when calling bookingV1DealOwnerDelete.'
      );
    }

    const queryParameters: runtime.HTTPQuery = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-App-Version'] = this.configuration.apiKey('X-App-Version'); // AppVersion authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Authorization'] = this.configuration.apiKey('Authorization'); // Bearer authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Device-Id'] = this.configuration.apiKey('X-Device-Id'); // DeviceId authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Device-Type'] = this.configuration.apiKey('X-Device-Type'); // DeviceType authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Os-Version'] = this.configuration.apiKey('X-Os-Version'); // OsVersion authentication
    }

    const response = await this.request({
      path: `/booking/v1/deal/owner/{id}/`.replace(`{${'id'}}`, encodeURIComponent(String(requestParameters.id))),
      method: 'DELETE',
      headers: headerParameters,
      query: queryParameters,
    });

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async bookingV1DealOwnerDelete(requestParameters: BookingV1DealOwnerDeleteRequest): Promise<void> {
    await this.bookingV1DealOwnerDeleteRaw(requestParameters);
  }

  /**
   */
  async bookingV1DealOwnerDocumentCreateRaw(
    requestParameters: BookingV1DealOwnerDocumentCreateRequest
  ): Promise<runtime.ApiResponse<Document>> {
    if (requestParameters.data === null || requestParameters.data === undefined) {
      throw new runtime.RequiredError(
        'data',
        'Required parameter requestParameters.data was null or undefined when calling bookingV1DealOwnerDocumentCreate.'
      );
    }

    const queryParameters: runtime.HTTPQuery = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-App-Version'] = this.configuration.apiKey('X-App-Version'); // AppVersion authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Authorization'] = this.configuration.apiKey('Authorization'); // Bearer authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Device-Id'] = this.configuration.apiKey('X-Device-Id'); // DeviceId authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Device-Type'] = this.configuration.apiKey('X-Device-Type'); // DeviceType authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Os-Version'] = this.configuration.apiKey('X-Os-Version'); // OsVersion authentication
    }

    const response = await this.request({
      path: `/booking/v1/deal/owner/document/`,
      method: 'POST',
      headers: headerParameters,
      query: queryParameters,
      body: DocumentToJSON(requestParameters.data),
    });

    return new runtime.JSONApiResponse(response, jsonValue => DocumentFromJSON(jsonValue));
  }

  /**
   */
  async bookingV1DealOwnerDocumentCreate(
    requestParameters: BookingV1DealOwnerDocumentCreateRequest
  ): Promise<Document> {
    const response = await this.bookingV1DealOwnerDocumentCreateRaw(requestParameters);
    return await response.value();
  }

  /**
   */
  async bookingV1DealOwnerDocumentDeleteRaw(
    requestParameters: BookingV1DealOwnerDocumentDeleteRequest
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters.id === null || requestParameters.id === undefined) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter requestParameters.id was null or undefined when calling bookingV1DealOwnerDocumentDelete.'
      );
    }

    const queryParameters: runtime.HTTPQuery = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-App-Version'] = this.configuration.apiKey('X-App-Version'); // AppVersion authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Authorization'] = this.configuration.apiKey('Authorization'); // Bearer authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Device-Id'] = this.configuration.apiKey('X-Device-Id'); // DeviceId authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Device-Type'] = this.configuration.apiKey('X-Device-Type'); // DeviceType authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Os-Version'] = this.configuration.apiKey('X-Os-Version'); // OsVersion authentication
    }

    const response = await this.request({
      path: `/booking/v1/deal/owner/document/{id}/`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(requestParameters.id))
      ),
      method: 'DELETE',
      headers: headerParameters,
      query: queryParameters,
    });

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async bookingV1DealOwnerDocumentDelete(requestParameters: BookingV1DealOwnerDocumentDeleteRequest): Promise<void> {
    await this.bookingV1DealOwnerDocumentDeleteRaw(requestParameters);
  }

  /**
   */
  async bookingV1DealOwnerDocumentListRaw(
    requestParameters: BookingV1DealOwnerDocumentListRequest
  ): Promise<runtime.ApiResponse<InlineResponse2006>> {
    const queryParameters: runtime.HTTPQuery = {};

    if (requestParameters.limit !== undefined) {
      queryParameters['limit'] = requestParameters.limit;
    }

    if (requestParameters.offset !== undefined) {
      queryParameters['offset'] = requestParameters.offset;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-App-Version'] = this.configuration.apiKey('X-App-Version'); // AppVersion authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Authorization'] = this.configuration.apiKey('Authorization'); // Bearer authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Device-Id'] = this.configuration.apiKey('X-Device-Id'); // DeviceId authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Device-Type'] = this.configuration.apiKey('X-Device-Type'); // DeviceType authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Os-Version'] = this.configuration.apiKey('X-Os-Version'); // OsVersion authentication
    }

    const response = await this.request({
      path: `/booking/v1/deal/owner/document/`,
      method: 'GET',
      headers: headerParameters,
      query: queryParameters,
    });

    return new runtime.JSONApiResponse(response, jsonValue => InlineResponse2006FromJSON(jsonValue));
  }

  /**
   */
  async bookingV1DealOwnerDocumentList(
    requestParameters: BookingV1DealOwnerDocumentListRequest
  ): Promise<InlineResponse2006> {
    const response = await this.bookingV1DealOwnerDocumentListRaw(requestParameters);
    return await response.value();
  }

  /**
   */
  async bookingV1DealOwnerDocumentPartialUpdateRaw(
    requestParameters: BookingV1DealOwnerDocumentPartialUpdateRequest
  ): Promise<runtime.ApiResponse<DocumentChange>> {
    if (requestParameters.id === null || requestParameters.id === undefined) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter requestParameters.id was null or undefined when calling bookingV1DealOwnerDocumentPartialUpdate.'
      );
    }

    if (requestParameters.data === null || requestParameters.data === undefined) {
      throw new runtime.RequiredError(
        'data',
        'Required parameter requestParameters.data was null or undefined when calling bookingV1DealOwnerDocumentPartialUpdate.'
      );
    }

    const queryParameters: runtime.HTTPQuery = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-App-Version'] = this.configuration.apiKey('X-App-Version'); // AppVersion authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Authorization'] = this.configuration.apiKey('Authorization'); // Bearer authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Device-Id'] = this.configuration.apiKey('X-Device-Id'); // DeviceId authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Device-Type'] = this.configuration.apiKey('X-Device-Type'); // DeviceType authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Os-Version'] = this.configuration.apiKey('X-Os-Version'); // OsVersion authentication
    }

    const response = await this.request({
      path: `/booking/v1/deal/owner/document/{id}/`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(requestParameters.id))
      ),
      method: 'PATCH',
      headers: headerParameters,
      query: queryParameters,
      body: DocumentChangeToJSON(requestParameters.data),
    });

    return new runtime.JSONApiResponse(response, jsonValue => DocumentChangeFromJSON(jsonValue));
  }

  /**
   */
  async bookingV1DealOwnerDocumentPartialUpdate(
    requestParameters: BookingV1DealOwnerDocumentPartialUpdateRequest
  ): Promise<DocumentChange> {
    const response = await this.bookingV1DealOwnerDocumentPartialUpdateRaw(requestParameters);
    return await response.value();
  }

  /**
   */
  async bookingV1DealOwnerDocumentReadRaw(
    requestParameters: BookingV1DealOwnerDocumentReadRequest
  ): Promise<runtime.ApiResponse<DocumentChange>> {
    if (requestParameters.id === null || requestParameters.id === undefined) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter requestParameters.id was null or undefined when calling bookingV1DealOwnerDocumentRead.'
      );
    }

    const queryParameters: runtime.HTTPQuery = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-App-Version'] = this.configuration.apiKey('X-App-Version'); // AppVersion authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Authorization'] = this.configuration.apiKey('Authorization'); // Bearer authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Device-Id'] = this.configuration.apiKey('X-Device-Id'); // DeviceId authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Device-Type'] = this.configuration.apiKey('X-Device-Type'); // DeviceType authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Os-Version'] = this.configuration.apiKey('X-Os-Version'); // OsVersion authentication
    }

    const response = await this.request({
      path: `/booking/v1/deal/owner/document/{id}/`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(requestParameters.id))
      ),
      method: 'GET',
      headers: headerParameters,
      query: queryParameters,
    });

    return new runtime.JSONApiResponse(response, jsonValue => DocumentChangeFromJSON(jsonValue));
  }

  /**
   */
  async bookingV1DealOwnerDocumentRead(
    requestParameters: BookingV1DealOwnerDocumentReadRequest
  ): Promise<DocumentChange> {
    const response = await this.bookingV1DealOwnerDocumentReadRaw(requestParameters);
    return await response.value();
  }

  /**
   */
  async bookingV1DealOwnerListRaw(
    requestParameters: BookingV1DealOwnerListRequest
  ): Promise<runtime.ApiResponse<InlineResponse2007>> {
    const queryParameters: runtime.HTTPQuery = {};

    if (requestParameters.search !== undefined) {
      queryParameters['search'] = requestParameters.search;
    }

    if (requestParameters.ordering !== undefined) {
      queryParameters['ordering'] = requestParameters.ordering;
    }

    if (requestParameters.limit !== undefined) {
      queryParameters['limit'] = requestParameters.limit;
    }

    if (requestParameters.offset !== undefined) {
      queryParameters['offset'] = requestParameters.offset;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-App-Version'] = this.configuration.apiKey('X-App-Version'); // AppVersion authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Authorization'] = this.configuration.apiKey('Authorization'); // Bearer authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Device-Id'] = this.configuration.apiKey('X-Device-Id'); // DeviceId authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Device-Type'] = this.configuration.apiKey('X-Device-Type'); // DeviceType authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Os-Version'] = this.configuration.apiKey('X-Os-Version'); // OsVersion authentication
    }

    const response = await this.request({
      path: `/booking/v1/deal/owner/`,
      method: 'GET',
      headers: headerParameters,
      query: queryParameters,
    });

    return new runtime.JSONApiResponse(response, jsonValue => InlineResponse2007FromJSON(jsonValue));
  }

  /**
   */
  async bookingV1DealOwnerList(requestParameters: BookingV1DealOwnerListRequest): Promise<InlineResponse2007> {
    const response = await this.bookingV1DealOwnerListRaw(requestParameters);
    return await response.value();
  }

  /**
   */
  async bookingV1DealOwnerPartialUpdateRaw(
    requestParameters: BookingV1DealOwnerPartialUpdateRequest
  ): Promise<runtime.ApiResponse<ChangeOwner>> {
    if (requestParameters.id === null || requestParameters.id === undefined) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter requestParameters.id was null or undefined when calling bookingV1DealOwnerPartialUpdate.'
      );
    }

    if (requestParameters.data === null || requestParameters.data === undefined) {
      throw new runtime.RequiredError(
        'data',
        'Required parameter requestParameters.data was null or undefined when calling bookingV1DealOwnerPartialUpdate.'
      );
    }

    const queryParameters: runtime.HTTPQuery = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-App-Version'] = this.configuration.apiKey('X-App-Version'); // AppVersion authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Authorization'] = this.configuration.apiKey('Authorization'); // Bearer authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Device-Id'] = this.configuration.apiKey('X-Device-Id'); // DeviceId authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Device-Type'] = this.configuration.apiKey('X-Device-Type'); // DeviceType authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Os-Version'] = this.configuration.apiKey('X-Os-Version'); // OsVersion authentication
    }

    const response = await this.request({
      path: `/booking/v1/deal/owner/{id}/`.replace(`{${'id'}}`, encodeURIComponent(String(requestParameters.id))),
      method: 'PATCH',
      headers: headerParameters,
      query: queryParameters,
      body: ChangeOwnerToJSON(requestParameters.data),
    });

    return new runtime.JSONApiResponse(response, jsonValue => ChangeOwnerFromJSON(jsonValue));
  }

  /**
   */
  async bookingV1DealOwnerPartialUpdate(
    requestParameters: BookingV1DealOwnerPartialUpdateRequest
  ): Promise<ChangeOwner> {
    const response = await this.bookingV1DealOwnerPartialUpdateRaw(requestParameters);
    return await response.value();
  }

  /**
   */
  async bookingV1DealOwnerReadRaw(
    requestParameters: BookingV1DealOwnerReadRequest
  ): Promise<runtime.ApiResponse<ChangeOwner>> {
    if (requestParameters.id === null || requestParameters.id === undefined) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter requestParameters.id was null or undefined when calling bookingV1DealOwnerRead.'
      );
    }

    const queryParameters: runtime.HTTPQuery = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-App-Version'] = this.configuration.apiKey('X-App-Version'); // AppVersion authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Authorization'] = this.configuration.apiKey('Authorization'); // Bearer authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Device-Id'] = this.configuration.apiKey('X-Device-Id'); // DeviceId authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Device-Type'] = this.configuration.apiKey('X-Device-Type'); // DeviceType authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Os-Version'] = this.configuration.apiKey('X-Os-Version'); // OsVersion authentication
    }

    const response = await this.request({
      path: `/booking/v1/deal/owner/{id}/`.replace(`{${'id'}}`, encodeURIComponent(String(requestParameters.id))),
      method: 'GET',
      headers: headerParameters,
      query: queryParameters,
    });

    return new runtime.JSONApiResponse(response, jsonValue => ChangeOwnerFromJSON(jsonValue));
  }

  /**
   */
  async bookingV1DealOwnerRead(requestParameters: BookingV1DealOwnerReadRequest): Promise<ChangeOwner> {
    const response = await this.bookingV1DealOwnerReadRaw(requestParameters);
    return await response.value();
  }

  /**
   */
  async bookingV1DealPartialUpdateRaw(
    requestParameters: BookingV1DealPartialUpdateRequest
  ): Promise<runtime.ApiResponse<DealUpdate>> {
    if (requestParameters.data === null || requestParameters.data === undefined) {
      throw new runtime.RequiredError(
        'data',
        'Required parameter requestParameters.data was null or undefined when calling bookingV1DealPartialUpdate.'
      );
    }

    const queryParameters: runtime.HTTPQuery = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-App-Version'] = this.configuration.apiKey('X-App-Version'); // AppVersion authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Authorization'] = this.configuration.apiKey('Authorization'); // Bearer authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Device-Id'] = this.configuration.apiKey('X-Device-Id'); // DeviceId authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Device-Type'] = this.configuration.apiKey('X-Device-Type'); // DeviceType authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Os-Version'] = this.configuration.apiKey('X-Os-Version'); // OsVersion authentication
    }

    const response = await this.request({
      path: `/booking/v1/deal/`,
      method: 'PATCH',
      headers: headerParameters,
      query: queryParameters,
      body: DealUpdateToJSON(requestParameters.data),
    });

    return new runtime.JSONApiResponse(response, jsonValue => DealUpdateFromJSON(jsonValue));
  }

  /**
   */
  async bookingV1DealPartialUpdate(requestParameters: BookingV1DealPartialUpdateRequest): Promise<DealUpdate> {
    const response = await this.bookingV1DealPartialUpdateRaw(requestParameters);
    return await response.value();
  }

  /**
   */
  async bookingV1DealReadRaw(): Promise<runtime.ApiResponse<Deal>> {
    const queryParameters: runtime.HTTPQuery = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-App-Version'] = this.configuration.apiKey('X-App-Version'); // AppVersion authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Authorization'] = this.configuration.apiKey('Authorization'); // Bearer authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Device-Id'] = this.configuration.apiKey('X-Device-Id'); // DeviceId authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Device-Type'] = this.configuration.apiKey('X-Device-Type'); // DeviceType authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Os-Version'] = this.configuration.apiKey('X-Os-Version'); // OsVersion authentication
    }

    const response = await this.request({
      path: `/booking/v1/deal/`,
      method: 'GET',
      headers: headerParameters,
      query: queryParameters,
    });

    return new runtime.JSONApiResponse(response, jsonValue => DealFromJSON(jsonValue));
  }

  /**
   */
  async bookingV1DealRead(): Promise<Deal> {
    const response = await this.bookingV1DealReadRaw();
    return await response.value();
  }

  /**
   * Метод отправки данных в AmoCrm
   */
  async bookingV1DealSendListRaw(): Promise<runtime.ApiResponse<void>> {
    const queryParameters: runtime.HTTPQuery = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-App-Version'] = this.configuration.apiKey('X-App-Version'); // AppVersion authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Authorization'] = this.configuration.apiKey('Authorization'); // Bearer authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Device-Id'] = this.configuration.apiKey('X-Device-Id'); // DeviceId authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Device-Type'] = this.configuration.apiKey('X-Device-Type'); // DeviceType authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Os-Version'] = this.configuration.apiKey('X-Os-Version'); // OsVersion authentication
    }

    const response = await this.request({
      path: `/booking/v1/deal/send/`,
      method: 'GET',
      headers: headerParameters,
      query: queryParameters,
    });

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Метод отправки данных в AmoCrm
   */
  async bookingV1DealSendList(): Promise<void> {
    await this.bookingV1DealSendListRaw();
  }

  /**
   */
  async bookingV1NoteCreateRaw(requestParameters: BookingV1NoteCreateRequest): Promise<runtime.ApiResponse<Note>> {
    if (requestParameters.data === null || requestParameters.data === undefined) {
      throw new runtime.RequiredError(
        'data',
        'Required parameter requestParameters.data was null or undefined when calling bookingV1NoteCreate.'
      );
    }

    const queryParameters: runtime.HTTPQuery = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-App-Version'] = this.configuration.apiKey('X-App-Version'); // AppVersion authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Authorization'] = this.configuration.apiKey('Authorization'); // Bearer authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Device-Id'] = this.configuration.apiKey('X-Device-Id'); // DeviceId authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Device-Type'] = this.configuration.apiKey('X-Device-Type'); // DeviceType authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Os-Version'] = this.configuration.apiKey('X-Os-Version'); // OsVersion authentication
    }

    const response = await this.request({
      path: `/booking/v1/note/`,
      method: 'POST',
      headers: headerParameters,
      query: queryParameters,
      body: NoteToJSON(requestParameters.data),
    });

    return new runtime.JSONApiResponse(response, jsonValue => NoteFromJSON(jsonValue));
  }

  /**
   */
  async bookingV1NoteCreate(requestParameters: BookingV1NoteCreateRequest): Promise<Note> {
    const response = await this.bookingV1NoteCreateRaw(requestParameters);
    return await response.value();
  }

  /**
   */
  async bookingV1NoteListRaw(
    requestParameters: BookingV1NoteListRequest
  ): Promise<runtime.ApiResponse<InlineResponse2008>> {
    const queryParameters: runtime.HTTPQuery = {};

    if (requestParameters.search !== undefined) {
      queryParameters['search'] = requestParameters.search;
    }

    if (requestParameters.ordering !== undefined) {
      queryParameters['ordering'] = requestParameters.ordering;
    }

    if (requestParameters.limit !== undefined) {
      queryParameters['limit'] = requestParameters.limit;
    }

    if (requestParameters.offset !== undefined) {
      queryParameters['offset'] = requestParameters.offset;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-App-Version'] = this.configuration.apiKey('X-App-Version'); // AppVersion authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Authorization'] = this.configuration.apiKey('Authorization'); // Bearer authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Device-Id'] = this.configuration.apiKey('X-Device-Id'); // DeviceId authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Device-Type'] = this.configuration.apiKey('X-Device-Type'); // DeviceType authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Os-Version'] = this.configuration.apiKey('X-Os-Version'); // OsVersion authentication
    }

    const response = await this.request({
      path: `/booking/v1/note/`,
      method: 'GET',
      headers: headerParameters,
      query: queryParameters,
    });

    return new runtime.JSONApiResponse(response, jsonValue => InlineResponse2008FromJSON(jsonValue));
  }

  /**
   */
  async bookingV1NoteList(requestParameters: BookingV1NoteListRequest): Promise<InlineResponse2008> {
    const response = await this.bookingV1NoteListRaw(requestParameters);
    return await response.value();
  }

  /**
   * Метод отправки данных заполненых данных по типу собственности в AmoCrm Возможные значения у списка documents: [\'passport\', \'inn\', \'snils\', \'birth_certificate\', \'child_representative_approval\', \'marriage_contract\', \'spouses_notarial_consent\', \'passport_original\', \'apostille\', \'maternal_capital_certificate\', \'mortgage_certificate\', \'subsidy_certificate\']
   */
  async bookingV1OwnershipListRaw(): Promise<runtime.ApiResponse<Array<OwnershipTypesResponse>>> {
    const queryParameters: runtime.HTTPQuery = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-App-Version'] = this.configuration.apiKey('X-App-Version'); // AppVersion authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Authorization'] = this.configuration.apiKey('Authorization'); // Bearer authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Device-Id'] = this.configuration.apiKey('X-Device-Id'); // DeviceId authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Device-Type'] = this.configuration.apiKey('X-Device-Type'); // DeviceType authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Os-Version'] = this.configuration.apiKey('X-Os-Version'); // OsVersion authentication
    }

    const response = await this.request({
      path: `/booking/v1/ownership/`,
      method: 'GET',
      headers: headerParameters,
      query: queryParameters,
    });

    return new runtime.JSONApiResponse(response, jsonValue => jsonValue.map(OwnershipTypesResponseFromJSON));
  }

  /**
   * Метод отправки данных заполненых данных по типу собственности в AmoCrm Возможные значения у списка documents: [\'passport\', \'inn\', \'snils\', \'birth_certificate\', \'child_representative_approval\', \'marriage_contract\', \'spouses_notarial_consent\', \'passport_original\', \'apostille\', \'maternal_capital_certificate\', \'mortgage_certificate\', \'subsidy_certificate\']
   */
  async bookingV1OwnershipList(): Promise<Array<OwnershipTypesResponse>> {
    const response = await this.bookingV1OwnershipListRaw();
    return await response.value();
  }

  /**
   * Метод отправки данных по типу собственности в AmoCrm
   */
  async bookingV1OwnershipSendListRaw(): Promise<runtime.ApiResponse<void>> {
    const queryParameters: runtime.HTTPQuery = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-App-Version'] = this.configuration.apiKey('X-App-Version'); // AppVersion authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Authorization'] = this.configuration.apiKey('Authorization'); // Bearer authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Device-Id'] = this.configuration.apiKey('X-Device-Id'); // DeviceId authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Device-Type'] = this.configuration.apiKey('X-Device-Type'); // DeviceType authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Os-Version'] = this.configuration.apiKey('X-Os-Version'); // OsVersion authentication
    }

    const response = await this.request({
      path: `/booking/v1/ownership/send/`,
      method: 'GET',
      headers: headerParameters,
      query: queryParameters,
    });

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Метод отправки данных по типу собственности в AmoCrm
   */
  async bookingV1OwnershipSendList(): Promise<void> {
    await this.bookingV1OwnershipSendListRaw();
  }

  /**
   * Метод возвращает данные по типам оплат
   */
  async bookingV1PaymentListRaw(): Promise<runtime.ApiResponse<PaymentTypesResponse>> {
    const queryParameters: runtime.HTTPQuery = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-App-Version'] = this.configuration.apiKey('X-App-Version'); // AppVersion authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Authorization'] = this.configuration.apiKey('Authorization'); // Bearer authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Device-Id'] = this.configuration.apiKey('X-Device-Id'); // DeviceId authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Device-Type'] = this.configuration.apiKey('X-Device-Type'); // DeviceType authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Os-Version'] = this.configuration.apiKey('X-Os-Version'); // OsVersion authentication
    }

    const response = await this.request({
      path: `/booking/v1/payment/`,
      method: 'GET',
      headers: headerParameters,
      query: queryParameters,
    });

    return new runtime.JSONApiResponse(response, jsonValue => PaymentTypesResponseFromJSON(jsonValue));
  }

  /**
   * Метод возвращает данные по типам оплат
   */
  async bookingV1PaymentList(): Promise<PaymentTypesResponse> {
    const response = await this.bookingV1PaymentListRaw();
    return await response.value();
  }

  /**
   */
  async createMortgageOrderRaw(requestParameters: MortgageRequest): Promise<runtime.ApiResponse<{ link: string }>> {
    const queryParameters: runtime.HTTPQuery = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-App-Version'] = this.configuration.apiKey('X-App-Version'); // AppVersion authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Authorization'] = this.configuration.apiKey('Authorization'); // Bearer authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Device-Id'] = this.configuration.apiKey('X-Device-Id'); // DeviceId authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Device-Type'] = this.configuration.apiKey('X-Device-Type'); // DeviceType authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Os-Version'] = this.configuration.apiKey('X-Os-Version'); // OsVersion authentication
    }

    const response = await this.request({
      path: `/booking/v1/mortgage-application/create`,
      method: 'POST',
      headers: headerParameters,
      query: queryParameters,
      body: { ...requestParameters },
    });

    return new runtime.JSONApiResponse(response, jsonValue => jsonValue);
  }

  /**
   */
  async createMortgageOrder(requestParameters: MortgageRequest): Promise<{ link: string }> {
    const response = await this.createMortgageOrderRaw(requestParameters);
    return await response.value();
  }
}
